import { useState, useEffect } from 'react';
import axios from 'axios';
import { printLogs } from '../utils/Utilities';

const useLocation = () => {
  const [location, setLocation] = useState({
    latitude: null,
    longitude: null,
    country: null,
    error: null,
  });

  const getIpDetails = async (ip) => {
    try {
      const url = `https://ipinfo.io/${ip}/json?token=d66e265587c913`;
      printLogs(url)
      const response = await axios.get(
        url
      );
      setLocation((prevState) => ({
        ...prevState,
        country: response.data.country,
      }));
    } catch (error) {
      setLocation((prevState) => ({
        ...prevState,
        error: 'Could not fetch country information',
      }));
    }
  }

  useEffect(() => {
    const path = window.location.pathname;
    if (path.includes('/order-payment') || path.includes('/order-accepted-success')) {
      return;
    }

    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        async (position) => {
          const { latitude, longitude } = position.coords;

          setLocation((prevState) => ({
            ...prevState,
            latitude,
            longitude,
          }));

          await fetch("https://api.ipify.org?format=json")
            .then((response) => response.json())
            .then((data) => {

              // setIp(data.ip); // Set IP address
              // Fetch country information based on latitude and longitude

              getIpDetails(data.ip);


            })
            .catch((error) => console.error("Error fetching IP address:", error));


        },
        (error) => {
          setLocation((prevState) => ({
            ...prevState,
            error: 'Geolocation failed. Please enable location services.',
          }));
        }
      );
    } else {
      setLocation((prevState) => ({
        ...prevState,
        error: 'Geolocation is not supported by this browser.',
      }));
    }
  }, []);

  return location;
};

export default useLocation;
